import { default as React, useContext } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { ShadowPricesDto } from "core/backend/data";
import classNames from "classnames";
import { keys } from "ts-transformer-keys";
import { MultiSelectItem } from "components/multiselect";
import BorderName from "components/borderName";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: ShadowPricesDto[];
    hubs: MultiSelectItem[];
}

const List = ({ t, data, hubs, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const keysInDto = keys<ShadowPricesDto>();
    const dtoHubs = hubs.filter((x) => keysInDto.some((key) => key.toLowerCase().endsWith(x.id.toLowerCase())));

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn fixedHeader" style={{ top: top + "px", left: left + "px" }}></th>
                    <th colSpan={22} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:infoCnec")}</th>
                    <th colSpan={hubs.length} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:ptdfs")}</th>
                </tr>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>

                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:tso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:cneName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:cneEic")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:direction")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:contName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:branchEic")}</th>

                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_shadowPrices:shadowPrice")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:ram")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:imax")}</th>
                    <th className="fixedHeader" style={{ top: top + "px", whiteSpace: "nowrap" }}>{t("page_shadowPrices:fmax")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:frm")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:fref")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:f0core")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:f0all")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:fuaf")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:amr")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:ltaMargin")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:cva")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:iva")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:ftotalLtn")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:minRamFactor")}</th>

                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:maxZ2ZPtdf")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:hubFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_shadowPrices:hubTo")}</th>
                    {dtoHubs.map((hub) => <th key={hub.id} className="fixedHeader" style={{ top: top + "px" }}>{hub.id}</th>)}
                </tr>
            </thead>
            <tbody>
                {
                    data && data.map((d) => <Row key={d.id} dto={d} left={left} hubs={dtoHubs} />)
                }
            </tbody>
        </table>
    )
}

const translated = withTranslation("page_shadowPrices")(List);

export default translated;